import { render, staticRenderFns } from "./oatask.vue?vue&type=template&id=030e893c&scoped=true"
import script from "./oatask.vue?vue&type=script&lang=js"
export * from "./oatask.vue?vue&type=script&lang=js"
import style0 from "./oatask.vue?vue&type=style&index=0&id=030e893c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030e893c",
  null
  
)

export default component.exports